import { put, select, takeLatest, call } from "redux-saga/effects";
import { loginSetFlowStageWatcher } from "../actions/loginactioncreators";
import { handleError } from "../actions/loginactioncreators";
import actiontypes from "../actions/actiontypes";
import getFlowStage from "../helpers/getFlowStage";
import { CognitoClient } from "../../lib/cognitoClient";

export function* changeEmail(action) {
    const flowStage = yield select(getFlowStage);
    let nextStage = "AUTHENTICATED";

    switch (flowStage) {
        case "EMAIL_NOT_VERIFIED":
            // update the Cognito login with the new email address
            try {
                const cognitoResponse = yield call(CognitoClient.updateUserEmail, action.payload);
                if (!cognitoResponse.isUpdated) {
                    nextStage = "VERIFY_EMAIL";
                }
                yield put(loginSetFlowStageWatcher({ flowStage: nextStage }));
            } catch (error) {
                yield put(handleError(error));
            }
            break;
        case "VERIFY_EMAIL":
            // verify the confirmation code sent to the new email address
            try {
                yield call(CognitoClient.confirmNewEmail, action.payload);
                yield put(loginSetFlowStageWatcher({ flowStage: nextStage }));
            } catch (error) {
                yield put(handleError(error));
            }
            break;
        // case "SKIP_EMAIL_NOT_VERIFIED":
        //     // user is skipping change email
        //     yield put(loginSetFlowStageWatcher({ flowStage: "AUTHENTICATED_FIRST_TIME" }));
        //     break;
        default:
            yield put(handleError(`Invalid flowStage = ${flowStage}`));
            break;
    }
}

export function* watchChangeEmail() {
    yield takeLatest(actiontypes.USER_CHANGE_EMAIL, changeEmail);
}